import moment from 'moment';

export default {
  props: ['id', 'date', 'editing'],

  created() {
    this.updateActiveDate(this.date ? moment(this.date).toDate() : this.activeDate, true);
  },

  computed: {
    activeDate() {
      return this.$store.state.activeDate;
    },

    editingCartItem() {
      return this.editing ? this.$cart.active.items.find(item => {
        return item.id === this.editing;
      }) : null;
    },    
  },

  methods: {
    updateActiveDate(val, hard = false, doRefresh = true) {
      this.$store.dispatch('setActiveDate', val);
      let name = this.$router.history.current.name ? this.$router.history.current.name : this.type;
      if(this.routeName){
        name = this.routeName;
      }
      let query = { ...this.$router.history.current.query };
      query.date = moment(this.activeDate).format('YYYY-MM-DD');

      // make sure we actually have a cart item to edit. Otherwise, fix the URL. Tthis handles back button from cart after edit.
      // Updating a cart item provides a new cart.id (delete, add)
      if (this.editing && !this.editingCartItem) {
        delete query.editing;
      }

      this.updateRouteState(name, query);

      if (doRefresh) {
        this.refreshModel(hard);
      }
    },

    // override this if you need to do more stuff with the query
    updateRouteState(name, query) {
      this.$router.replace({ name, query });      
    },

    refreshModel(hard = false) {}, // meant to be overridden
  }
}